import axionIns from "../axios";

const getCapital = async (payload) => {
  return axionIns.get("capital/" + payload).then((response) => { return response.data });
};

const addCapital = async (payload) => {
  return axionIns.post("capital", JSON.stringify(payload)).then((response) => { return response.data });
};

const getSinglePaidUp = async (paidupId) => {
  return axionIns.get(`capital/paidup/${paidupId}`).then((response) => { return response.data });
};

const exportObject = {
  getCapital,
  addCapital,
  getSinglePaidUp
};
export default exportObject;
